let googleScriptPromise = null;
let initializedForClientId = null;

export function getGoogleClientId() {
  return process.env.VUE_APP_GOOGLE_CLIENT_ID || "";
}

export function isGoogleAuthEnabled() {
  return !!getGoogleClientId();
}

export function loadGoogleIdentityScript() {
  if (typeof window === "undefined") {
    return Promise.reject(new Error("no window"));
  }
  if (window.google && window.google.accounts && window.google.accounts.id) {
    return Promise.resolve();
  }
  if (googleScriptPromise) {
    return googleScriptPromise;
  }
  googleScriptPromise = new Promise((resolve, reject) => {
    const existing = document.querySelector('script[data-starsender-gis="1"]');
    if (existing) {
      existing.addEventListener("load", () => resolve());
      existing.addEventListener("error", () => reject(new Error("Google script failed")));
      return;
    }
    const script = document.createElement("script");
    script.src = "https://accounts.google.com/gsi/client";
    script.async = true;
    script.defer = true;
    script.dataset.starsenderGis = "1";
    script.onload = () => resolve();
    script.onerror = () => reject(new Error("Google script failed"));
    document.head.appendChild(script);
  });
  return googleScriptPromise;
}

function initializeGoogleIdentity(callback) {
  const clientId = getGoogleClientId();
  if (!clientId) {
    return false;
  }
  window.google.accounts.id.initialize({
    client_id: clientId,
    callback,
    auto_select: false,
    cancel_on_tap_outside: true,
  });
  initializedForClientId = clientId;
  return true;
}

/**
 * Renders GIS button in `hostElement` (typically invisible overlay) for custom-branded UI.
 */
export async function mountGoogleSignInHost(hostElement, callback, options = {}) {
  const clientId = getGoogleClientId();
  if (!clientId || !hostElement) {
    return false;
  }
  await loadGoogleIdentityScript();
  if (initializedForClientId !== clientId) {
    initializeGoogleIdentity(callback);
  } else {
    initializeGoogleIdentity(callback);
  }

  hostElement.innerHTML = "";
  const width = options.width || Math.min(400, hostElement.offsetWidth || 320);

  window.google.accounts.id.renderButton(hostElement, {
    type: "standard",
    theme: "outline",
    size: "large",
    text: "continue_with",
    shape: "rectangular",
    width,
    locale: options.locale || "id",
  });
  return true;
}

/** @deprecated Use GoogleSignInButton + mountGoogleSignInHost */
export async function mountGoogleButton(element, callback) {
  return mountGoogleSignInHost(element, callback);
}
